export default __webpack_public_path__ + "static/image5-d9b8404ed09769676f7a4bf372f07180.jpeg";